export default __webpack_public_path__ + "static/media/good-times2.4ea1be17.jpg";